var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.BOverlay,
    {
      staticClass: "p-3 border rounded",
      staticStyle: { "max-height": "500px", "overflow-y": "scroll" },
      attrs: { show: _setup.loading },
    },
    [
      _c(
        "div",
        { staticClass: "row grid" },
        [
          _setup.isItemSizeValidFrame
            ? _c(
                "a",
                {
                  staticClass: "col-sm-6 col-lg-4 col-xl-3 mb-3",
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _setup.selectSize(_setup.props.itemSize)
                    },
                  },
                },
                [
                  _c(_setup.FrameDesignOption, {
                    attrs: {
                      "length-sku": _setup.props.lengthSku,
                      mount: _setup.props.mount,
                      "from-price": _setup.noMountPrice,
                      "item-size": _setup.props.itemSize,
                      selected:
                        _setup.selectedFrameSize.name ===
                        _setup.props.itemSize.name,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._l(_setup.frameSizes, function (frameSize, idx) {
            return _c(
              "a",
              {
                key: idx,
                staticClass: "col-sm-6 col-lg-4 col-xl-3 mb-3",
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _setup.selectSize(frameSize)
                  },
                },
              },
              [
                _c(_setup.FrameDesignOption, {
                  attrs: {
                    "length-sku": _setup.props.lengthSku,
                    mount: _setup.props.mount,
                    "from-price": frameSize.price,
                    "item-size": _setup.props.itemSize,
                    "frame-size": frameSize,
                    selected: _setup.selectedFrameSize.name === frameSize.name,
                  },
                }),
              ],
              1
            )
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }